import { Button } from '../../components/ui/Button';
import { ImgWithSkeleton } from '../../components/ui/ImgWithSkeleton';
import { FavoriteButton } from '../../components/FavoriteButton';
import { AddToItineraryButton } from '../../components/AddToItineraryButton';
import { SHOW_VENUE_LOGO } from '../../config/featureFlags';
import type { WineryHeaderProps } from './types';

export const WineryHeader = ({ venue, mediaList, canManage, onManageClick }: WineryHeaderProps) => {
  const logo = venue.logoImageId ? mediaList.find((media) => media.id === venue.logoImageId) : null;

  return (
    <div className="flex justify-between items-center !mt-2">
      <div className="flex items-center gap-4">
        {SHOW_VENUE_LOGO && (
          <div className="h-24 max-w-[20%] rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden bg-gray-50">
            <ImgWithSkeleton
              src={logo ? logo.cloudinaryUrl : '/assets/placeholders/placeholder-winery-logo.png'}
              alt={`${venue.name} logo`}
              fallbackSrc="/assets/placeholders/placeholder-winery-logo.png"
              className="h-full w-auto max-w-full object-contain p-2.5"
              skeletonClassName="rounded-lg"
            />
          </div>
        )}
        <div className="flex flex-col justify-center">
          <div className="flex items-center gap-3">
            <h1 className="text-3xl">{venue.name}</h1>
            {venue.isClaimed && (
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2.5 py-0.5 text-xs font-medium text-primary-800 border border-primary-200">
                <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.403 12.652a3 3 0 010-5.304 3 3 0 00-3.75-3.751 3 3 0 00-5.305 0 3 3 0 00-3.751 3.75 3 3 0 000 5.305 3 3 0 003.75 3.751 3 3 0 005.305 0 3 3 0 003.751-3.75zm-2.546-4.46a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                </svg>
                Verified by winery
              </span>
            )}
          </div>
          <p className="text-gray-600">
            {venue.address.city}, {venue.address.state}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <AddToItineraryButton venueId={venue._id} venueName={venue.name} />
        <FavoriteButton entityType="venue" entityId={venue._id} />
        {canManage && (
          <Button variant="primary" onClick={onManageClick}>
            Manage
          </Button>
        )}
      </div>
    </div>
  );
};
